export enum ErrorCode {
  success,
  generalError,
  invalidArgumentError,
  elementCannotHaveChildren,
  elementNotAnArrayCannotHaveCount,
  invalidSetElementIsKeyword,
  elementIsReadOnly,
  elementIsWriteOnly,
  incorrectDataType
}

export class SchemaError {
  constructor(
    private code: ErrorCode,
    private message: string) {
  }

  get errorCode() {
    return this.code;
  }

  get diagnosticMessage() {
    return this.message;
  }
}

export function error(code: ErrorCode, diagnosticMessage: string) {
  return new SchemaError(code, diagnosticMessage);
}

export function parseErrorCode(codeString: string): ErrorCode {

  return parseInt(codeString, 10) as ErrorCode;
}
